import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-532ef0b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full h-full" }
const _hoisted_2 = { class: "flex flex-col mt-auto w-full space-y-14 pb-5" }
const _hoisted_3 = { class: "flex flex-col w-full space-y-14" }
const _hoisted_4 = { class: "flex w-full justify-around px-10" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_6 = { class: "text-white text-xl font-semibold w-full text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-sm w-full text-center" }, "Please enter your PIN", -1))
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col space-y-1"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "animate-wiggle text-red-600 text-xl font-semibold w-full text-center" }, "Incorrect PIN!", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-sm w-full text-center" }, "Try again.", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "flex flex-col space-y-1 px-10"
}
const _hoisted_13 = {
  key: 0,
  class: "text-white text-xl font-semibold w-full text-center"
}
const _hoisted_14 = {
  key: 1,
  class: "text-white text-xl font-semibold w-full text-center"
}
const _hoisted_15 = {
  key: 2,
  class: "animate-wiggle text-red-600 text-xl font-semibold w-full text-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-sm w-full text-center" }, "To enhance your privacy, you can choose to enter a PIN every time you open the app.", -1))
const _hoisted_17 = { class: "safe-area-bottom grid grid-cols-3 px-5 justify-evenly w-full items-center justify-center my-auto" }
const _hoisted_18 = ["innerHTML"]

import {
  IonContent,
  IonButton,
  IonPage, modalController, useIonRouter, useBackButton,
} from '@ionic/vue';
import LogoMark from "@/components/LogoMark.vue";
import {computed, onMounted, onUnmounted, Ref, ref, watch} from "vue";
import AuthService from "@/services/api/auth/authService";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {DateTime} from "luxon";
import OneSignal from "onesignal-cordova-plugin";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {BiometryType, NativeBiometric} from "capacitor-native-biometric";
import {UserInterface} from "@/interfaces/UserInterface";
import ApiService from "@/services/api/apiService";
import {App} from "@capacitor/app";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {PluginListenerHandle} from "@capacitor/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppResumed',
  setup(__props) {

const pad = [
    '1','2','3','4','5','6','7','8','9','','0','&larr;'
]

const pin = ref('')

const ionRouter = useIonRouter()
const logout = async () => {
  const authService = new AuthService()
  await authService.logout(() => {
    ionRouter.replace('/')
  })
}

const keyPressed = async (keyIndex: number) => {

  Haptics.impact({ style: ImpactStyle.Medium });

  if (keyIndex === 9) return
  if (keyIndex === 11) {
    return pin.value = pin.value.slice(0, pin.value.length - 1)
  }
  if (pin.value.length === 4) return

  pin.value = pin.value + pad[keyIndex]

}

const close = async () => {
  modalController.dismiss()
}

const skip = async () => {
  modalController.dismiss()
  Preferences.set({key: PreferenceKey.PrivacyPin, value: ''})
}

const startAgain = async () => {
  newPin.value = ''
  newPinConfirmation.value = ''
  pin.value = ''
}

const biometricsBusy = ref(false)

const performBiometricVerification = async () => {

  if (biometricsBusy.value) return
  biometricsBusy.value = true

  setTimeout(async () => {

    const result = await NativeBiometric.isAvailable();

    if (!result.isAvailable) return;
    const verified = await NativeBiometric.verifyIdentity({
      reason: "For easy pin verification",
      title: "Authenticate",
      maxAttempts: 1
    })
        .then(() => true)
        .catch(() => false);

    if (!verified) {
      setTimeout(()=>{
        biometricsBusy.value = false
      }, 1000)
      return;
    }

    const credentials = await NativeBiometric.getCredentials({
      server: "thepineapple.app",
    });

    pin.value = credentials.password
    biometricsBusy.value = false

  }, 300)
}

const user: Ref<UserInterface|undefined> = ref()
const listener: Ref<PluginListenerHandle|undefined> = ref()
const backButton = useBackButton(999, () => {
  // disables back button
})

onMounted(async ()=>{

  user.value = await ApiService.User().authUser()
  storedPin.value = (await Preferences.get({key: PreferenceKey.PrivacyPin})).value ?? ''

  listener.value = App.addListener('appStateChange', async (state) => {
    if (state.isActive) {
      // await performBiometricVerification()
    }
  })

  if (hasPin.value) {
    // return await performBiometricVerification()
  }

})

onUnmounted(()=>{
  backButton.unregister()
  listener.value?.remove()
})

const storedPin = ref('')
const storedPinError = ref(false)

const hasPin = computed(()=>{
  return storedPin.value.length
})

const newPin = ref('')
const newPinConfirmation = ref('')
const newPinError = ref(false)

watch(()=>pin.value, async value => {

  if (hasPin.value) {
    if (value.length === 4 && storedPin.value === value) return close()
    if (value.length === 4 && storedPin.value !== value) {
      storedPinError.value = true
      setTimeout(()=>{
        pin.value = ''
      },50)
      setTimeout(()=>{
        storedPinError.value = false
        pin.value = ''
      },1000)
      return
    }
  }

  if (!hasPin.value) {

    if (!newPin.value && value.length === 4) {
      newPin.value = value
      pin.value = ''
      return
    }

    if (newPin.value && value.length === 4) {
      newPinConfirmation.value = value

      if (newPin.value === newPinConfirmation.value) {
        // await NativeBiometric.setCredentials({
        //   username: "username",
        //   password: pin.value,
        //   server: "thepineapple.app",
        // })
        await Preferences.set({key: PreferenceKey.PrivacyPin, value: newPin.value})
        await close()
        return
      }
      if (newPin.value !== newPinConfirmation.value) {
        newPinError.value = true
        setTimeout(()=>{
          pin.value = ''
        },50)
        setTimeout(()=>{
          newPinError.value = false
          pin.value = ''
        },1000)
        return
      }

    }

  }
})





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (hasPin.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: logout,
                  class: "absolute text-lg text-white font-bold top-0 right-0 safe-area-top pr-6 mt-5"
                }, "Log out"))
              : _createCommentVNode("", true),
            (!hasPin.value && !newPin.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: skip,
                  class: "absolute text-lg text-white font-bold top-0 right-0 safe-area-top pr-6 mt-5"
                }, "Skip"))
              : _createCommentVNode("", true),
            (!hasPin.value && newPin.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  onClick: startAgain,
                  class: "absolute text-lg text-white font-bold top-0 right-0 safe-area-top pr-6 mt-5"
                }, "Start again"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(LogoMark, { class: "m-auto w-10" }),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4], (i, index) => {
                    return _createElementVNode("div", {
                      key: index,
                      class: _normalizeClass([{
                    'bg-brand-lime !scale-150' : (pin.value.length-1) >= index,
                  }, "w-3 h-3 scale-100 bg-brand-dark-gray rounded-full transition-all transition-transform"])
                    }, null, 2)
                  }), 64))
                ]),
                (hasPin.value && !storedPinError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, "Hey " + _toDisplayString(user.value.name) + " 👋", 1),
                      _hoisted_7
                    ]))
                  : _createCommentVNode("", true),
                (hasPin.value && storedPinError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                  : _createCommentVNode("", true),
                (!hasPin.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (!newPin.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Create PIN 🔒"))
                        : _createCommentVNode("", true),
                      (newPin.value && !newPinError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Re-enter to confirm PIN 🔒"))
                        : _createCommentVNode("", true),
                      (newPin.value && newPinError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Incorrect PIN!"))
                        : _createCommentVNode("", true),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pad, (key, keyIndex) => {
                  return _createVNode(_unref(IonButton), {
                    key: keyIndex,
                    onClick: ($event: any) => (keyPressed(keyIndex)),
                    class: "text-center h-16 flex"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "m-auto font-bold text-white",
                        innerHTML: key
                      }, null, 8, _hoisted_18)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                }), 64))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})